import { api } from "./client.js";
export const sessionsApi = {
    list: ({ range }) => api
        .get("api/sessions", { searchParams: { range } })
        .json(),
    detail: (id) => api.get(`api/sessions/${id}`).json(),
    cancel: (id) => api
        .delete(`api/sessions/${id}`)
        .json(),
};
